import { useMaterialUIController } from "context";
import logo from "../../assets/images/logos/logo.png";
import logoDark from "../../assets/images/logos/logo_dark.png";
import MDBox from "components/MDBox";

const Logo = () => {
    const [controller] = useMaterialUIController();
    const { darkMode } = controller;

    return (
        <MDBox
            component="img"
            src={darkMode ? logoDark : logo}
            alt="Logo"
            sx={{
                width: "100%",
                height: "100%",
                objectFit: "contain",
                mixBlendMode: darkMode ? "screen" : "multiply", // Efeito de transparência artificial
                filter: "brightness(1.1)", // Pequeno boost para compensar a mesclagem
            }}
        />
    );
};

export default Logo;